import React from 'react'
import MetlinkLeadSuppportComponent from '../Components/MetlinkLeadSupport/MetlinkLeadSuppportComponent'

const MetlinkLeadSupportPage = () => {
  return (
    <MetlinkLeadSuppportComponent/>
)
}

export default MetlinkLeadSupportPage